import { render, staticRenderFns } from "./ModalRubrique.vue?vue&type=template&id=1b8a6abb&scoped=true"
import script from "./ModalRubrique.vue?vue&type=script&lang=js"
export * from "./ModalRubrique.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8a6abb",
  null
  
)

export default component.exports